import React, {
  createContext,
  useState,
  useCallback,
  useMemo,
  useContext,
} from "react";
import {
  TextInput,
  ImageInput,
  ImageField,
  required,
  useDataProvider,
  useNotify,
  SaveContextProvider,
  useGetIdentity,
  TabbedForm,
  FormTab,
  ArrayField,
  Datagrid,
  DateField,
  TextField,
  FileField,
  ArrayInput,
  SimpleFormIterator
} from "react-admin";
import Button from "@material-ui/core/Button";
import {DateInput} from '../components/pickers';

import * as firebase from "firebase/app";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profileVersion, setProfileVersion] = useState(0);
  const context = useMemo(
    () => ({
      profileVersion,
      refreshProfile: () =>
        setProfileVersion((currentVersion) => currentVersion + 1),
    }),
    [profileVersion]
  );

  return (
    <ProfileContext.Provider value={context}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);

export const ProfileEdit = ({ staticContext, ...props}) => {
  console.log("ProfileEdit");
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [saving, setSaving] = useState();
  const { refreshProfile } = useProfile();

  const { loaded, identity } = useGetIdentity();

  const handleSave = useCallback(
    (values) => {
      setSaving(true);
      dataProvider.updateUserProfile(
        { data: values },
        {
          onSuccess: ({ data }) => {
            setSaving(false);
            notify("Your profile has been updated", "info", {
              _: "Your profile has been updated",
            });
            refreshProfile();
          },
          onFailure: () => {
            setSaving(false);
            notify(
              "A technical error occured while updating your profile. Please try later.",
              "warning",
              {
                _:
                  "A technical error occured while updating your profile. Please try later.",
              }
            );
          },
        }
      );
    },
    [dataProvider, notify, refreshProfile]
  );

  const saveContext = useMemo(
    () => ({
      save: handleSave,
      saving,
    }),
    [saving, handleSave]
  );

  var actionCodeSettings = {
    url: "https://admin.logicaljupiter.eu/login",
  };

  const sendPasswordEmail = () => {
    var auth = firebase.auth();
    const emailAddress = auth.currentUser.email;
    console.log(emailAddress);
    auth
      .sendPasswordResetEmail(emailAddress, actionCodeSettings)
      .then(function () {
        console.log("Email sent, please check your email");
        notify("Email sent, please check your email", "info", {
          _: "Email sent, please check your email",
        });
      })
      .catch(function (error) {
        console.log(error.message);
        notify(
          error.message,
          "warning",
          {
            _:
            error.message,
          }
        );

      });
  };

  if (!loaded) {
    return null;
  }

  

  return (
    <SaveContextProvider value={saveContext}>
      <TabbedForm
        redirect={false}
        save={handleSave}
        record={identity ? identity : {}}
      >
        <FormTab label="Details">
          <TextField source="firstname" validate={required()} />
          <TextField source="lastname" validate={required()} />
        </FormTab>
        <FormTab label="Profile">
          <ImageInput
            source="photo"
            placeholder={<p>Put here the photo</p>}
            validate={required()}
          >
            <ImageField source="src" title="title" />
          </ImageInput>
        </FormTab>
        <FormTab label="Docs">
          <ArrayField source="docs" label="Docs">
            <Datagrid style={{ width: "100%" }}>
              <DateField label="Date" source="date" locales="lt" />
              <TextField label="Description" source="description" />
              <FileField
                label="Doc"
                source="file.src"
                title="file.title"
                target="_blank"
              />
            </Datagrid>
          </ArrayField>
        </FormTab>
        <FormTab label="VACATIONS">
        <ArrayInput source="vacations" label="">
          <SimpleFormIterator>
            <DateInput  validate={required()} source="dateStart" label="Start Date" options={{ format: 'dd/MM/yyyy' }}></DateInput>
            <DateInput  validate={required()} source="dateEnd" label="End Date" options={{ format: 'dd/MM/yyyy' }}></DateInput>
            <TextInput  source="notes" label="Notes" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
      <FormTab
            label="Credentials"
          >
            <TextField label="Reset" />
            <Button
              variant="contained"
              color="primary"
              onClick={sendPasswordEmail} 
            >
              {'Reset'}
            </Button>
          </FormTab>
      </TabbedForm>
    </SaveContextProvider>
  );
};



// WEBPACK FOOTER //
// ./src/layout/profile.js